var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.33,
    y2: 0.415,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aeff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1587.5,20.367a23.353,23.353,0,0,1-9.147-1.847,23.423,23.423,0,0,1-7.47-5.036,23.425,23.425,0,0,1-5.036-7.47A23.352,23.352,0,0,1-1611-3.132a23.353,23.353,0,0,1,1.847-9.147,23.426,23.426,0,0,1,5.036-7.47,23.423,23.423,0,0,1,7.47-5.036,23.352,23.352,0,0,1,9.147-1.847,23.352,23.352,0,0,1,9.147,1.847,23.422,23.422,0,0,1,7.47,5.036,23.422,23.422,0,0,1,5.036,7.47A23.355,23.355,0,0,1-1564-3.132a23.354,23.354,0,0,1-1.847,9.147,23.421,23.421,0,0,1-5.036,7.47,23.422,23.422,0,0,1-7.47,5.036A23.354,23.354,0,0,1-1587.5,20.367Zm0-43.452a19.975,19.975,0,0,0-19.953,19.953A19.975,19.975,0,0,0-1587.5,16.82a19.975,19.975,0,0,0,19.953-19.953A19.975,19.975,0,0,0-1587.5-23.085Z",
    transform: "translate(1611 26.633)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIconCircle);
export default __webpack_public_path__ + "static/media/question_mark_icon_circle.e759875a704b682a50abb427fc012938.svg";
export { ForwardRef as ReactComponent };